module.exports = __webpack_public_path__ + "static/media/Popup_SolarShade.0f228c9b.png";